/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
export default {
  applicationIdText: 'Application Id',
  statsPerformText: 'Stats Perform'
};